import { h, render } from "preact";
import SwatchModal from "./swatch-modal/swatch-modal";
import "./pdp-swatch-modal-wrapper";

class PdpSwatchModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const data = window.scrapeSectionData(this);

    if (!data.products?.length) return;

    render(
      <SwatchModal
        products={data.products}
        localeStrings={data.localeStrings}
        limitEach={data.limitEach}
        modalContent={data.modalContent}
        swatchType={data.swatchType}
      />,
      this.querySelector("[data-container]"),
    );
  }
}

if (!customElements.get("pdp-swatch-modal")) {
  customElements.define("pdp-swatch-modal", PdpSwatchModal);
}
